import * as React from 'react';
import { IBikesList } from '../../../interfaces';
import { IBikeItem } from '../../../../bike/interfaces';
import FormattedNumber from '../../../../react/common/components/FormattedNumber';
import Tooltip from '../../../../react/common/components/Tooltip';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

interface IBikeListProps {
    bikeLists: IBikesList[];
}

const BikeList: React.FunctionComponent<IBikeListProps> = props => {
    const { bikeLists } = props;
    const { translate } = useTranslationHook();

    if (!bikeLists) {
        return null;
    }

    const displayListContent = () =>  bikeLists.map((bikeList: IBikesList) => (
        <React.Fragment key={`bikelist-${bikeList.name}`}>
            <tr>
                <td className='title' colSpan={4}>
                    <h4>{bikeList.name}</h4>
                </td>
            </tr>
            {displayBikes(bikeList.bikes)}
        </React.Fragment>
    ));

    const displayBikes = (bikes: IBikeItem[]) => bikes.map((bike: IBikeItem) => {

        const bikeNameData = React.useCallback(() => (
            <Tooltip
                id={`tooltip-bike-${bike.idBike}`}
                content={<img src={bike.images[0].externalUrlMedium} alt={`${bike.manufacturer} ${bike.model}`}/>}
                isHoverEnabled={true}
                isDisplayInline={false}
                showInfoIcon={false}
                showCloseIcon={false}
            >
                <p className='paragraph-s'>
                    <a href={bike.url} className={`tooltip-icon`} data-tooltip={`tooltip-bike-${bike.idBike}`}>
                        <strong>{`${bike.manufacturer} ${bike.marketingName}`}</strong>
                    </a>
                </p>
            </Tooltip>
        ), [bike]);

        return (<tr key={`bikelist-item-${bike.idBike}`}>
            <td>
                {bikeNameData()}
            </td>
            <td>
                <p className='paragraph-s'>{bike.model}</p>
            </td>
            <td>
                <p className='paragraph-s'>
                    {(bike.manufactureYearStart || bike.manufactureYearEnd) ? (bike.manufactureYearStart ||
                        '...') + ' - ' + (bike.manufactureYearEnd || '...') : ''}
                </p>
            </td>
            <td>
                <p className='paragraph-s'>
                    <FormattedNumber number={bike.engineSize}/>&nbsp;{translate('cc', { ns: 'bike-db'})}
                </p>
            </td>
        </tr>
        )
    });

    return (
        <div className='cell bike-list-container'>
            <table>
                <thead>
                    <tr>
                        <th><span className='header'>{translate('Type designation', { ns: 'bike-db'})}</span></th>
                        <th><span className='header'>{translate('Type ID', { ns: 'bike-db'})}</span></th>
                        <th><span className='header'>{translate('Year of manufacture', { ns: 'bike-db'})}</span></th>
                        <th><span className='header'>{translate('Engine size', { ns: 'bike-db'})}</span></th>
                    </tr>
                </thead>

                <tbody>
                    {displayListContent()}
                </tbody>
            </table>
        </div>
    );
};

BikeList.defaultProps = {};

export default BikeList;
